<template>
	<div class="digital-human-page">
		<div class="page-header">
			<div class="action-area">
				<el-button size="small" type="primary" @click="createDialogVisible = true">
					<i class="el-icon-plus"></i> 创建数字人视频
				</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="human-card-list">
				<div v-for="item in humanList" :key="item.digitalHumanId" class="human-card">
					<div class="card-header">
						<div class="human-name">{{ item.digitalHumanName }}</div>
						<el-tag :type="item.digitalHumanVideo ? 'success' : 'warning'" size="small">
							{{ item.digitalHumanVideo ? '已完成' : '处理中' }}
						</el-tag>
					</div>
					<div class="card-body">
						<div class="content-row">
							<div class="content-item">
								<div class="content-label">人物形象</div>
								<el-image :src="item.digitalHumanImage" fit="cover" class="content-image" />
							</div>
							<div class="content-item">
								<div class="content-label">音频</div>
								<div class="audio-preview">
									<audio :src="item.digitalHumanAudio" controls class="audio-player" />
								</div>
							</div>
							<div class="content-item">
								<div class="content-label">结果视频</div>
								<template v-if="item.digitalHumanVideo">
									<video :src="item.digitalHumanVideo" controls class="video-preview" />
								</template>
								<div v-else class="content-empty">
									<i class="el-icon-loading"></i>
									<span>处理中...</span>
								</div>
							</div>
						</div>
						<div class="text-content" style="display: none;">
							<div class="content-label">文本内容</div>
							<p class="text-preview">{{ truncateText(item.digitalHumanText) }}</p>
						</div>
						<div class="card-footer">
							<span class="create-time">创建时间: {{ item.digitalHumanAddTime }}</span>
							<div class="card-actions">
								<el-button size="mini" type="primary" @click="handleRefreshTask(item)"
									v-if="!item.digitalHumanVideo">
									<i class="el-icon-refresh"></i> 刷新
								</el-button>
								<el-button size="mini" type="danger" @click="handleDelete(item.digitalHumanId)">
									<i class="el-icon-delete"></i> 删除
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="humanList.length === 0" class="empty-state">
					<i class="el-icon-user"></i>
					<p>暂无数字人视频</p>
				</div>
			</div>
		</div>
		<div class="pagination-area">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>

		<el-dialog :visible.sync="createDialogVisible" title="创建数字人视频" width="700px">
			<el-form :model="createForm" label-width="100px">
				<el-form-item label="任务名称">
					<el-input v-model="createForm.taskName" placeholder="请输入任务名称"></el-input>
				</el-form-item>

				<el-form-item label="人物形象">
					<div class="upload-bar">
						<i class="el-icon-user"></i>
						<span>{{ createForm.imageName || '未选择人物形象' }}</span>
						<el-dropdown trigger="click" @command="handleImageCommand">
							<span class="upload-btn">
								<i class="el-icon-plus"></i>
								选择形象
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="upload">上传本地文件</el-dropdown-item>
								<el-dropdown-item command="library">选择素材库</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div v-if="createForm.imageUrl" class="asset-preview-area">
						<el-image :src="createForm.imageUrl" fit="cover" style="width: 50%; max-height: 50%;" />
					</div>
				</el-form-item>
				<el-form-item label="台词">
					<el-input type="textarea" v-model="createForm.content" maxlength="2000" show-word-limit :rows="4"
						placeholder="请输入台词" />
				</el-form-item>
				<el-form-item label="数字人音频">
					<div class="upload-bar">
						<i class="el-icon-headset"></i>
						<span>{{ createForm.audioName || '未选择音频' }}</span>
						<el-dropdown trigger="click" @command="handleAudioCommand">
							<span class="upload-btn">
								<i class="el-icon-plus"></i>
								选择音频
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="upload">上传本地文件</el-dropdown-item>
								<el-dropdown-item command="library">选择素材库</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div v-if="createForm.audioUrl" class="asset-preview-area">
						<audio :src="createForm.audioUrl" controls style="width: 100%;" />
					</div>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleCancel">取消</el-button>
				<el-button type="primary" @click="handleSubmit" :loading="submitLoading">开始创建</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择素材" :visible.sync="materialDialogVisible" width="800px" @open="onMaterialDialogOpen">
			<div class="asset-filter-group" style="display: none;">
				<button class="filter-btn" :class="{ active: searchForm.type === '1' }"
					@click="searchForm.type = '1'; fetchAssetLibrary()">图片</button>
				<button class="filter-btn" :class="{ active: searchForm.type === '2' }"
					@click="searchForm.type = '2'; fetchAssetLibrary()">音频</button>
			</div>
			<div class="asset-library-list">
				<template v-if="assetLibraryData.length > 0">
					<div v-for="asset in assetLibraryData" :key="asset.resourceId" class="asset-item"
						@click="selectAssetFromLibrary(asset)">
						<div v-if="asset.resourceCate === 1" class="asset-preview">
							<img :src="asset.resourceUrl" :alt="asset.resourceName"
								style="width: 100%; max-height: 200px;">
						</div>
						<div v-else-if="asset.resourceCate === 2" class="asset-preview audio-preview-item">
							<audio :src="asset.resourceUrl" controls style="width: 100%;" />
						</div>
						<span class="asset-name">{{ asset.resourceName }}</span>
					</div>
				</template>
				<div v-else class="empty-state">
					<i class="el-icon-picture"></i>
					<p>暂无素材</p>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="uploadDialogVisible" title="上传资产" width="500px">
			<el-form :model="uploadForm" label-width="100px">
				<el-form-item label="资产名称">
					<el-input v-model="uploadForm.resourceName" placeholder="请输入资产名称"></el-input>
				</el-form-item>
				<el-form-item label="是否公开">
					<el-switch v-model="uploadForm.resourceType" active-text="公开" inactive-text="私有"></el-switch>
				</el-form-item>
				<el-form-item label="资产类型">
					<el-radio-group v-model="uploadForm.resourceCate">
						<el-radio label="1">形象</el-radio>
						<el-radio label="2">音频</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材性别">
					<el-radio-group v-model="uploadForm.resourceGender">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="0">女</el-radio>
						<el-radio :label="2">其他</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材上传">
					<el-upload :action="`${baseUrl}/resource/upload?token=${adminInfo.adminToken}`"
						:accept="getAcceptType()" :show-file-list="true" :file-list="uploadFileList"
						:on-success="handleFileUploadSuccess" :on-change="handleFileChange" :auto-upload="false"
						:limit="1" :on-exceed="handleExceed">
						<el-button size="small" type="primary">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="素材备注">
					<el-input v-model="uploadForm.resourceRemark" type="textarea" placeholder="请输入备注信息"
						:rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="uploadDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitUploadAsset">确定上传</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'

	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'DigitalHuman',
		data() {
			return {
				baseUrl: BASE_URL,
				humanList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				createDialogVisible: false,
				materialDialogVisible: false,
				uploadDialogVisible: false,
				submitLoading: false,
				materialSelectType: '',
				assetLibraryData: [],
				searchForm: {
					type: ''
				},
				createForm: {
					taskName: '',
					content: '',
					imageUrl: '',
					imageName: '',
					audioUrl: '',
					audioName: ''
				},
				uploadForm: {
					resourceName: '',
					resourceType: true,
					resourceCate: '1',
					resourceGender: 1,
					resourceRemark: ''
				},
				uploadFileList: [],
				adminInfo: {},
				taskId: '',
				pollingTimer: null,
				isPolling: false,
				pollingRetryCount: 0,
				maxRetryCount: 60
			}
		},
		mounted() {
			this.adminInfo = JSON.parse(localStorage.getItem('adminInfo'))
			this.fetchList()
		},
		methods: {
			handleImageCommand(command) {
				if (command === 'upload') {
					this.uploadForm.resourceCate = '1'
					this.uploadDialogVisible = true
				} else {
					this.materialSelectType = 'image'
					this.searchForm.type = '1'
					this.materialDialogVisible = true
				}
			},
			handleAudioCommand(command) {
				if (command === 'upload') {
					this.uploadForm.resourceCate = '2'
					this.uploadDialogVisible = true
				} else {
					this.materialSelectType = 'audio'
					this.searchForm.type = '2'
					this.materialDialogVisible = true
				}
			},
			onMaterialDialogOpen() {
				this.fetchAssetLibrary()
			},
			async fetchAssetLibrary() {
				try {
					const params = {
						token: this.adminInfo.adminToken,
						pageNum: 1,
						pageCount: 99999,
						resourceCate: this.searchForm.type
					}
					if (this.adminInfo.adminLevel > 0) {
						params.adminId = this.adminInfo.adminId
					}
					const res = await axios.get(`${BASE_URL}/resource/list`, {
						params
					})
					if (res.data.length > 0) {
						this.assetLibraryData = res.data
					}
				} catch (error) {
					this.$message.error('加载素材失败')
				}
			},
			selectAssetFromLibrary(asset) {
				if (this.materialSelectType === 'image') {
					this.createForm.imageUrl = asset.resourceUrl
					this.createForm.imageName = asset.resourceName
				} else {
					this.createForm.audioUrl = asset.resourceUrl
					this.createForm.audioName = asset.resourceName
				}
				this.materialDialogVisible = false
			},
			async fetchList() {
				try {
					const params = {
						token: this.adminInfo.adminToken,
						pageNum: this.currentPage,
						pageCount: this.pageSize
					}
					if (this.adminInfo.adminLevel > 0) {
						params.adminId = this.adminInfo.adminId
					}
					const res = await axios.get(`${BASE_URL}/digital_human/list`, {
						params
					})
					const data = res.data
					this.humanList = data
					if (data.length > 0) {
						this.total = data[0].allcount
					} else {
						this.total = 0
					}
				} catch (error) {
					console.error('获取数字人列表失败:', error)
					this.$message.error('获取列表失败')
				}
			},
			getAcceptType() {
				switch (this.uploadForm.resourceCate) {
					case '1':
						return 'image/*'
					case '2':
						return 'audio/*'
					default:
						return ''
				}
			},
			handleFileUploadSuccess(response) {
				if (response.resourceUrl) {
					this.$message.success('文件上传成功')
				}
			},
			handleFileChange(file, fileList) {
				if (file.status === 'ready') {
					this.uploadFileList = [file]
					if (!this.uploadForm.resourceName) {
						this.uploadForm.resourceName = file.name.replace(/\.[^/.]+$/, '')
					}
				} else if (file.status === 'removed') {
					this.uploadFileList = fileList
				}
			},
			handleExceed() {
				this.$message.warning('只能上传一个文件')
			},
			submitUploadAsset() {
				if (!this.uploadForm.resourceName) {
					this.$message.warning('请输入资产名称')
					return
				}
				if (!this.uploadFileList || !this.uploadFileList.length) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				const file = this.uploadFileList[0].raw || this.uploadFileList[0]
				if (!file || !file.name) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				const info = localStorage.getItem('adminInfo')
				let adminId = 1
				if (info) {
					const adminInfo = JSON.parse(info)
					adminId = adminInfo.adminId || 1
				}
				const formData = new FormData()
				formData.append('file', file)
				axios.post(`${this.baseUrl}/resource/upload?token=${this.adminInfo.adminToken}`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					const fileUrl = res.data.data.url
					if (this.uploadForm.resourceCate === '1') {
						this.createForm.imageUrl = fileUrl
						this.createForm.imageName = this.uploadForm.resourceName
					} else if (this.uploadForm.resourceCate === '2') {
						this.createForm.audioUrl = fileUrl
						this.createForm.audioName = this.uploadForm.resourceName
					}
					const addData = {
						resourceName: this.uploadForm.resourceName,
						resourceType: this.uploadForm.resourceType ? 1 : 0,
						resourceCate: parseInt(this.uploadForm.resourceCate),
						resourceUrl: fileUrl,
						resourceSize: file.size,
						resourceGender: this.uploadForm.resourceGender,
						resourceRemark: this.uploadForm.resourceRemark,
						adminId: adminId
					}
					axios.post(`${this.baseUrl}/resource/add?token=${this.adminInfo.adminToken}`, addData).then(
						() => {
							this.uploadDialogVisible = false
							this.uploadForm = {
								resourceName: '',
								resourceType: true,
								resourceCate: '1',
								resourceGender: 1,
								resourceRemark: ''
							}
							this.uploadFileList = []
							this.$message.success('上传成功')
						}).catch(() => {
						this.$message.error('添加资产失败')
					})
				}).catch(() => {
					this.$message.error('上传文件失败')
				})
			},
			async handleRefreshTask(row) {
				try {
					let taskId_refresh = row.digitalHumanTaskid
					if (!taskId_refresh) {
						const requestBody2 = {
							image_url: row.digitalHumanImage,
							audio_url: row.digitalHumanAudio
						}
						const res2 = await axios.post(
							`${BASE_URL}/volcano_ark/cv_submit_task?token=${this.adminInfo.adminToken}`,
							requestBody2)
						var data2 = JSON.parse(res2.data.data)
						if (data2.code === 10000) {
							taskId_refresh = data2.data.task_id
						}
						if (!taskId_refresh) {
							this.$message.success('排队中，请稍后刷新')
							return
						}
					}

					const res = await axios.post(
						`${BASE_URL}/volcano_ark/task_query_cv_submit_task?token=${this.adminInfo.adminToken}`, {
							req_key: "jimeng_realman_avatar_picture_omni_v15",
							task_id: taskId_refresh
						})
					const data = JSON.parse(res.data.data)
					if (data.data.status === 'done') {
						const videoUrl = data.data.video_url || ''
						if (videoUrl) {
							await axios.post(`${BASE_URL}/digital_human/update?token=${this.adminInfo.adminToken}`, {
								digitalHumanId: row.digitalHumanId,
								digitalHumanTaskid: taskId_refresh,
								digitalHumanName: row.digitalHumanName,
								digitalHumanAudio: row.digitalHumanAudio,
								digitalHumanText: row.digitalHumanText,
								digitalHumanImage: row.digitalHumanImage,
								digitalHumanVideo: videoUrl
							})
							this.$message.success('任务刷新成功')
							this.fetchList()
						}
					} else if (data.data.status === 'not_found' || data.data.status === 'expired') {
						this.$message.error('任务处理失败')
					} else {
						await axios.post(`${BASE_URL}/digital_human/update?token=${this.adminInfo.adminToken}`, {
							digitalHumanId: row.digitalHumanId,
							digitalHumanTaskid: taskId_refresh,
							digitalHumanName: row.digitalHumanName,
							digitalHumanAudio: row.digitalHumanAudio,
							digitalHumanText: row.digitalHumanText,
							digitalHumanImage: row.digitalHumanImage,
							digitalHumanVideo: ''
						})
						this.$message.info('任务正在处理中...')
						this.fetchList()
					}
				} catch (error) {
					this.$message.error('刷新任务失败')
				}
			},
			async handleSubmit() {
				if (!this.createForm.taskName) {
					this.$message.warning('请输入任务名称')
					return
				}
				if (!this.createForm.content) {
					this.$message.warning('请输入文本内容')
					return
				}
				if (!this.createForm.imageUrl) {
					this.$message.warning('请选择人物形象')
					return
				}
				if (!this.createForm.audioUrl) {
					this.$message.warning('请选择音频')
					return
				}

				this.submitLoading = true
				try {
					const requestBody3 = {
						model: 'seed-audio-1.0-multilingual',
						text_prompt: this.createForm.content,
						references: [{
							"audio_url": this.createForm.audioUrl
						}],
						"audio_config": {
							"format": "mp3",
							"sample_rate": 48000,
							"enable_subtitle": true
						}
					}
					const res3 = await axios.post(
						`${BASE_URL}/volcano_ark/tts_create?token=${this.adminInfo.adminToken}`, requestBody3)
					var data3 = JSON.parse(res3.data.data)
					if (res3.data.code === 0) {
						const requestBody2 = {
							image_url: this.createForm.imageUrl,
							audio_url: data3.url,
							prompt: this.createForm.content,
						}
						const res2 = await axios.post(
							`${BASE_URL}/volcano_ark/cv_submit_task?token=${this.adminInfo.adminToken}`,
							requestBody2)
						var data2 = JSON.parse(res2.data.data)
						if (data2.code === 10000) {
							this.taskId = data2.data.task_id
						}
						this.$message.success('任务创建成功')
						const requestBody = {
							digitalHumanName: this.createForm.taskName,
							digitalHumanTaskid: this.taskId,
							digitalHumanImage: this.createForm.imageUrl,
							digitalHumanAudio: data3.url,
							digitalHumanText: this.createForm.content,
							digitalHumanVideo: '',
							adminId: this.adminInfo.adminId
						}
						await axios.post(`${BASE_URL}/digital_human/add?token=${this.adminInfo.adminToken}`, requestBody)
						this.createDialogVisible = false
						const taskName = this.createForm.taskName
						this.createForm = {
							taskName: '',
							content: '',
							imageUrl: '',
							imageName: '',
							audioUrl: '',
							audioName: ''
						}
						await this.fetchList()
						if (this.taskId) {
							const newTask = this.humanList.find(item => item.digitalHumanName === taskName)
							if (!newTask || !newTask.digitalHumanVideo) {
								this.isPolling = true
								this.pollingRetryCount = 0
								this.$message.info('任务执行中，请稍候...')
								this.pollTaskStatus()
							}
						}

					}
				} catch (error) {
					this.$message.error('任务创建失败')
				} finally {
					this.submitLoading = false
				}
			},
			handleCancel() {
				this.createDialogVisible = false
				this.createForm = {
					taskName: '',
					content: '',
					imageUrl: '',
					imageName: '',
					audioUrl: '',
					audioName: ''
				}
			},
			async pollTaskStatus() {
				if (!this.taskId || !this.isPolling) return
				try {
					const res = await axios.post(
						`${BASE_URL}/volcano_ark/task_query_cv_submit_task?token=${this.adminInfo.adminToken}`, {
							req_key: "jimeng_realman_avatar_picture_omni_v15",
							task_id: this.taskId
						})
					var data = JSON.parse(res.data.data)
					if (data.data.status === 'done') {
						const videoUrl = data.data.video_url || ''
						if (videoUrl) {
							const task = this.humanList.find(item => item.digitalHumanTaskid === this.taskId)
							if (task) {
								await axios.post(
									`${BASE_URL}/digital_human/update?token=${this.adminInfo.adminToken}`, {
										digitalHumanId: task.digitalHumanId,
										digitalHumanTaskid: this.taskId,
										digitalHumanName: task.digitalHumanName,
										digitalHumanAudio: task.digitalHumanAudio,
										digitalHumanImage: task.digitalHumanImage,
										digitalHumanText: task.digitalHumanText,
										digitalHumanVideo: videoUrl,
									})
							}
							this.$message.success('数字人视频生成完成')
						}
						this.isPolling = false
						this.fetchList()
					} else if (data.data.status === 'not_found' || data.data.status === 'expired') {
						this.isPolling = false
						this.$message.error('任务处理失败')
					} else {
						this.pollingRetryCount++
						if (this.pollingRetryCount >= this.maxRetryCount) {
							this.isPolling = false
							this.$message.error('任务处理超时')
							return
						}
						this.pollingTimer = setTimeout(() => {
							this.pollTaskStatus()
						}, 10000)
					}
				} catch (error) {
					this.pollingRetryCount++
					if (this.pollingRetryCount >= this.maxRetryCount) {
						this.isPolling = false
						this.$message.error('任务查询超时')
						return
					}
					this.pollingTimer = setTimeout(() => {
						this.pollTaskStatus()
					}, 10000)
				}
			},
			async handleDelete(id) {
				this.$confirm('确定要删除这个数字人视频吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						await axios.get(`${BASE_URL}/digital_human/delete`, {
							params: {
								digitalHumanId: id,
								token: this.adminInfo.adminToken
							}
						})
						this.$message.success('删除成功')
						this.fetchList()
					} catch (error) {
						this.$message.error('删除失败')
					}
				}).catch(() => {
					this.$message.info('已取消删除')
				})
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.currentPage = 1
				this.fetchList()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchList()
			},
			truncateText(text) {
				if (!text) return ''
				return text.length > 50 ? text.substring(0, 50) + '...' : text
			}
		},
		beforeDestroy() {
			if (this.pollingTimer) {
				clearTimeout(this.pollingTimer)
				this.pollingTimer = null
			}
		}
	}
</script>

<style scoped>
	.digital-human-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px;
	}

	.page-header {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-bottom: 10px;
	}

	.action-area {
		display: flex;
		gap: 12px;
	}

	.table-container {
		flex: 1;
		overflow-y: auto;
	}

	.human-card-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
		gap: 20px;
	}

	.human-card {
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		transition: transform 0.2s ease, box-shadow 0.2s ease;
	}

	.human-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		background: linear-gradient(135deg, #10b981 0%, #059669 100%);
		color: #fff;
	}

	.human-name {
		font-size: 16px;
		font-weight: 600;
	}

	.card-body {
		padding: 20px;
	}

	.content-row {
		display: flex;
		gap: 16px;
		margin-bottom: 16px;
	}

	.content-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.content-label {
		font-size: 12px;
		color: #6b7280;
		font-weight: 500;
	}

	.content-image {
		width: 100%;
		height: 100px;
		border-radius: 8px;
		background-color: #f9fafb;
	}

	.audio-preview {
		display: flex;
		align-items: center;
		height: 100px;
		background-color: #f9fafb;
		border-radius: 8px;
		padding: 12px;
	}

	.audio-player {
		width: 100%;
		max-width: 150px;
	}

	.video-preview {
		width: 100%;
		max-height: 100px;
		border-radius: 8px;
	}

	.content-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100px;
		background-color: #f9fafb;
		border-radius: 8px;
		color: #9ca3af;
		gap: 8px;
	}

	.content-empty i {
		font-size: 24px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	.text-content {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-bottom: 16px;
		padding: 12px;
		background-color: #f9fafb;
		border-radius: 8px;
	}

	.text-preview {
		font-size: 13px;
		color: #374151;
		line-height: 1.6;
		margin: 0;
		word-break: break-all;
	}

	.card-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 16px;
		border-top: 1px solid #e5e7eb;
	}

	.create-time {
		font-size: 12px;
		color: #9ca3af;
	}

	.card-actions {
		display: flex;
		gap: 8px;
	}

	.pagination-area {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		padding-top: 16px;
		border-top: 1px solid #e5e7eb;
	}

	.empty-state {
		grid-column: 1 / -1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 80px 0;
		color: #9ca3af;
	}

	.empty-state i {
		font-size: 64px;
		margin-bottom: 16px;
		color: #d1d5db;
	}

	.empty-state p {
		font-size: 16px;
	}

	.upload-bar {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 3px 4px;
		background-color: #f9fafb;
		border-radius: 8px;
		border: 1px solid #e5e7eb;
	}

	.upload-bar i {
		font-size: 16px;
		color: #6b7280;
	}

	.upload-bar span:first-of-type {
		flex: 1;
		font-size: 14px;
		color: #374151;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.upload-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 1px 12px;
		background-color: #10b981;
		color: #fff;
		border-radius: 16px;
		font-size: 13px;
		cursor: pointer;
		transition: background-color 0.2s ease;
	}

	.upload-btn:hover {
		background-color: #10b981;
	}

	.asset-preview-area {
		margin-top: 16px;
		border-radius: 8px;
		overflow: hidden;
		background-color: #f9fafb;
		border: 1px solid #e5e7eb;
		max-height: 50%;
		width: 50%;
		overflow-y: auto;
		padding: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.hidden-input {
		display: none;
	}

	.asset-filter-group {
		display: flex;
		gap: 8px;
		margin-bottom: 16px;
		padding-bottom: 16px;
		border-bottom: 1px solid #e5e7eb;
	}

	.filter-btn {
		padding: 6px 16px;
		border: 1px solid #d1d5db;
		border-radius: 4px;
		background-color: #fff;
		cursor: pointer;
		font-size: 14px;
		color: #6b7280;
		transition: all 0.2s;
	}

	.filter-btn:hover {
		border-color: #4f46e5;
		color: #4f46e5;
	}

	.filter-btn.active {
		background-color: #4f46e5;
		color: #fff;
		border-color: #4f46e5;
	}

	.asset-library-list {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		max-height: 400px;
		overflow-y: auto;
		padding: 12px 0;
	}

	.asset-item {
		width: calc(25% - 10px);
		cursor: pointer;
		text-align: center;
	}

	.asset-preview {
		width: 100%;
		height: 80px;
		border-radius: 8px;
		overflow: hidden;
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.asset-preview img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.audio-preview-item {
		background-color: #1f2937;
		color: #fff;
	}

	.audio-preview-item i {
		font-size: 32px;
	}

	.asset-name {
		display: block;
		margin-top: 8px;
		font-size: 12px;
		color: #374151;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}

	::v-deep .el-dialog__body {
		max-height: 60vh;
		overflow-y: auto;
		padding: 20px 24px;
	}

	::v-deep .el-form-item {
		margin-bottom: 20px;
	}

	::v-deep .el-form-item__label {
		font-weight: 500;
		color: #374151;
		font-size: 14px;
	}

	::v-deep .el-dialog__footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		padding: 16px 24px;
	}

	::v-deep .el-dialog__header {
		padding: 20px 24px;
		border-bottom: 1px solid #e5e7eb;
	}

	::v-deep .el-dialog__title {
		font-size: 16px;
		font-weight: 600;
		color: #1f2937;
	}
</style>